import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiComicFilterConfig } from '@/data/landingConfig/landingAiComicFilterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiComicFilter } from './schemaObject';

interface Props {}
const AiComicFilter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiComicFilter} />
			<LandingTemplate
				data={landingAiComicFilterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiComicFilter;
